import React from "react";

const MobileStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5002 17.5H7C5.89543 17.5 5 16.6046 5 15.5V5C5 3.89543 5.89543 3 7 3H13.5002C14.6048 3 15.5002 3.89543 15.5002 5V15.5C15.5002 16.6046 14.6048 17.5 13.5002 17.5Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 15H10.5",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(MobileStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;